import React, { useEffect, useState } from 'react';
import teamImage from '../../assets/ContactUsOneHero.webp'; // Replace with your actual image path
import COLORS from '../../constants/colors';

const ContactOne = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Detect screen resize to toggle between mobile and desktop
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="text-white px-4" style={{ fontFamily: 'Quicksand, sans-serif', backgroundColor: COLORS.primaryBlue }}>
      {isMobile ? (
        // ---------------------- MOBILE VERSION ----------------------
        <div className="pt-8">
          <h2 className="text-[28px] font-semibold leading-snug text-left">
            The Right Legal Help <br />
            <span className="text-white">
              Is Just <span style={{ color: COLORS.yellow }}>One Message</span> Away
            </span>
          </h2>
          <p className="mt-4 text-[15px] text-left" style={{ color: COLORS.lightGray }}>
            We connect you with law firms that understand complex injury claims and treat your case with urgency and care.
          </p>
          <div className="mt-6">
            <img
              src={teamImage}
              alt="Legal Team"
              className="w-full h-auto object-cover rounded-md"
            />
          </div>
        </div>
      ) : (
        // ---------------------- DESKTOP VERSION ----------------------
        <div className="pt-12">
          <div className="max-w-7xl mx-auto grid md:grid-cols-2 items-center gap-8">
            {/* Left Content */}
            <div>
              <h2 className=" md:text-[27px] lg:text-[33px] xl:text-[40px] font-semibold leading-snug">
                The Right Legal Help <br />
                <span className="text-white">
                  Is Just <span style={{ color: COLORS.yellow }}>One Message</span> Away
                </span>
              </h2>
              <p className="mt-4 md:text-[11px] lg:text-[14px] xl:text-[18px] max-w-md" style={{ color: COLORS.lightGray }}>
                We connect you with law firms that understand complex injury claims and treat your case with urgency,
                compassion, and attention to detail.
              </p>
            </div>

            {/* Right Image */}
            <div className="flex flex-col justify-end h-full">
              <img
                src={teamImage}
                alt="Legal Team"
                className="w-full h-auto object-cover rounded-md self-end"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactOne;